export default __webpack_public_path__ + "static/media/VBJ.93c4c32c.jpg";